import "./loader.scss"

const Loader = ({status}) => {
    return (
        <div className="loader">
            <div className="spinner">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
            <p>{status}</p>
        </div>
    )
}

export default Loader;